export default __webpack_public_path__ + "static/media/Logo_aha_manual.084f559a.png";